<template>
  <v-card class="h-100">
    <v-chart ref="chart" :options="options" :init="chartInit" @contextmenu="contextmenu" />
  </v-card>
</template>

<script>
import { DEFAULT_COLORS } from '@/constants';
import chartable from '@/mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    system: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      default() {
        return DEFAULT_COLORS;
      },
    },
    grid: {
      type: Object,
      default() {
        return {
          top: '10px',
          bottom: '20px',
          left: '50px',
          right: '10px',
        };
      },
    },
    contextmenu: {
      type: Function,
      default: e => e,
    },
  },
  data: () => ({
    options: {},
    systemChanged: true,
    loading: false,
  }),
  computed: {
    echart() {
      return this.$refs.chart.$refs.chart.chart;
    },
    chartInit() {
      return {
        grid: this.grid,
        xAxis: {
          type: 'value',
          axisLabel: {
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        yAxis: {
          type: 'category',
          data: [''],
          axisLabel: {
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          formatter: params => this.tooltipFormatter(params),
        },
      };
    },
  },
  watch: {
    system: {
      immediate: true,
      handler: 'changSystemHandler',
    },
    items: {
      deep: true,
      handler: 'changItemsHandler',
    },
    values: {
      handler: 'changeValuesHandler',
    },
    isDark: {
      handler: 'changColorHandler',
    },
  },
  methods: {
    changSystemHandler() {
      this.systemChanged = true;
      this.loading = true;
    },
    changItemsHandler() {
      if (!this.systemChanged) this.changColorHandler();
    },
    changeValuesHandler() {
      this.$nextTick(() => {
        if (this.systemChanged) {
          this.options = this.getOptions();
          this.loading = false;
        } else {
          this.options = {
            animation: true,
            series: this.getSeries(),
          };
        }
        this.systemChanged = false;
      });
    },
    changColorHandler() {
      this.options.series.forEach((series, seriesIndex) => {
        series.data.forEach((data, dataIndex) => {
          this.options.series[seriesIndex].data[dataIndex].label.color = this.getReverseThemeColor(this.chartColor.splitArea, 10, 60);
          this.options.series[seriesIndex].data[dataIndex].itemStyle.color = this.getThemeColor(this.colors[seriesIndex], 10, 10);
          this.options.series[seriesIndex].data[dataIndex].itemStyle.opacity = this.items[dataIndex].active ? 0.8 : 0.2;
        });
      });
    },
    getOptions() {
      // console.log('in BarHorizontalStack.veu, getOptions(), this.items=', this.items);
      return {
        yAxis: {
          // data: this.items.map(item => item.id),
          data: this.items.map(item => item.shortAlias),
        },
        series: this.getSeries(),
      };
    },
    getSeries() {
      const types = this.values[0]; // item 별 구성하고 있는 stack 구성 요소
      return types.map((type, typeIndex) => ({
        type: 'bar',
        name: type.name,
        stack: 'stack',
        data: this.values.map((value, valueIndex) => ({
          value: value[typeIndex].value,
          label: {
            show: true,
            position: 'inside',
            color: this.getReverseThemeColor(this.chartColor.splitArea, 10, 60),
            formatter: param => (param.value ? `${param.value}` : ''),
          },
          itemStyle: {
            color: this.getThemeColor(this.colors[typeIndex], 10, 10),
            opacity: this.items[valueIndex].active ? 0.8 : 0.2,
          },
        })),
      }));
    },
    tooltipFormatter(params) {
      let total = 0;
      //const item = this.items.find(item => item.id == params[0].axisValue);
      const item = this.items.find(item => item.shortAlias == params[0].axisValue);
      if (!item) return '';
      this.$emit('update:selectedDescendant', item);
      //const label = [this.circle(item.color), `<span style="color:${item.color};font-weight:900;">`, item.id, '</span> : '];
      const label = [this.circle(item.color), `<span style="color:${item.color};font-weight:900;">`, item.shortAlias, '</span> : '];
      const list = params.map(param => {
        total += parseInt(param.value);
        return [`<span style="color:${param.color};font-weight:900;margin:0 0 0 10px;">`, param.seriesName, '</span> : ', param.value].join('');
      });
      label.push(total);
      list.unshift(label.join(''));
      return list.join('<br/>');
    },
  },
};
</script>
